export default __webpack_public_path__ + "static/result-3671041aed517d6a8466ad48a5900719.png";